const FORMAT = 'YYYY-MM-DD';
const ENUM_DATE = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year',
};

const yesterday = {
    label: window.i18n.__('Hier'),
    id: 'yesterday',
    action: () => [
        moment().subtract(1, ENUM_DATE.DAY).startOf(ENUM_DATE.DAY).format(FORMAT),
        moment().subtract(1, ENUM_DATE.DAY).startOf(ENUM_DATE.DAY).format(FORMAT),
    ],
};
const today = {
    label: window.i18n.__("Aujourd'hui"),
    id: 'today',
    action: () => [
        moment().startOf(ENUM_DATE.DAY).format(FORMAT),
        moment().endOf(ENUM_DATE.DAY).format(FORMAT),
    ],
};
const tomorrow = {
    label: window.i18n.__('Demain'),
    id: 'tomorrow',
    action: () => [
        moment().add(1, ENUM_DATE.DAY).startOf(ENUM_DATE.DAY).format(FORMAT),
        moment().add(1, ENUM_DATE.DAY).startOf(ENUM_DATE.DAY).format(FORMAT),
    ],
};

const last_week = {
    label: window.i18n.__('La semaine dernière'),
    id: 'last_week',
    action: () => [
        moment().subtract(1, ENUM_DATE.WEEK).startOf(ENUM_DATE.WEEK).format(FORMAT),
        moment().subtract(1, ENUM_DATE.WEEK).endOf(ENUM_DATE.WEEK).format(FORMAT),
    ],
};
const current_week = {
    label: window.i18n.__('Cette semaine'),
    id: 'current_week',
    action: () => [
        moment().startOf(ENUM_DATE.WEEK).format(FORMAT),
        moment().endOf(ENUM_DATE.WEEK).format(FORMAT),
    ],
};
const next_week = {
    label: window.i18n.__('La semaine prochaine'),
    id: 'next_week',
    action: () => [
        moment().add(1, ENUM_DATE.WEEK).startOf(ENUM_DATE.WEEK).format(FORMAT),
        moment().add(1, ENUM_DATE.WEEK).endOf(ENUM_DATE.WEEK).format(FORMAT),
    ],
};

const last_month = {
    label: window.i18n.__('Le mois dernier'),
    id: 'last_month',
    action: () => [
        moment().subtract(1, ENUM_DATE.MONTH).startOf(ENUM_DATE.MONTH).format(FORMAT),
        moment().subtract(1, ENUM_DATE.MONTH).endOf(ENUM_DATE.MONTH).format(FORMAT),
    ],
};
const current_month = {
    label: window.i18n.__('Ce mois-ci'),
    id: 'current_month',
    action: () => [
        moment().startOf(ENUM_DATE.MONTH).format(FORMAT),
        moment().endOf(ENUM_DATE.MONTH).format(FORMAT),
    ],
};
const next_month = {
    label: window.i18n.__('Le mois prochain'),
    id: 'next_month',
    action: () => [
        moment().add(1, ENUM_DATE.MONTH).startOf(ENUM_DATE.MONTH).format(FORMAT),
        moment().add(1, ENUM_DATE.MONTH).endOf(ENUM_DATE.MONTH).format(FORMAT),
    ],
};
const last_year = {
    label: window.i18n.__("L'année dernière"),
    id: 'last_year',
    action: () => [
        moment().subtract(1, ENUM_DATE.YEAR).startOf(ENUM_DATE.YEAR).format(FORMAT),
        moment().subtract(1, ENUM_DATE.YEAR).endOf(ENUM_DATE.YEAR).format(FORMAT),
    ],
};
const current_year = {
    label: window.i18n.__('Cette année'),
    id: 'current_year',
    action: () => [
        moment().startOf(ENUM_DATE.YEAR).format(FORMAT),
        moment().endOf(ENUM_DATE.YEAR).format(FORMAT),
    ],
};

const next_year = {
    label: window.i18n.__("L'année prochaine"),
    id: 'next_year',
    action: () => [
        moment().add(1, ENUM_DATE.YEAR).startOf(ENUM_DATE.YEAR).format(FORMAT),
        moment().add(1, ENUM_DATE.YEAR).endOf(ENUM_DATE.YEAR).format(FORMAT),
    ],
};

const getIntervalWithShortcut = (idShortcut) => {
    try {
        const interval = eval(idShortcut).action();
        return { startDate: interval[0], endDate: interval[1] };
    } catch {
        return { startDate: '', endDate: '' };
    }
};
const retrieveShortcutFromId = (idShortcut) => {
    return eval(idShortcut);
};
export {
    getIntervalWithShortcut,
    retrieveShortcutFromId,
    yesterday,
    today,
    tomorrow,
    last_week,
    current_week,
    next_week,
    last_month,
    current_month,
    next_month,
    last_year,
    current_year,
    next_year,
};
